<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <v-card>
          <v-card-title>
            Nada Encontrado

            <router-link  class="nav-link" to="/adm/home"><button>Home</button></router-link>
          </v-card-title>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  }
};
</script>